// Thin wrapper around the checkout sell sheet (PaymentModalV2) that fires the
// initiate-checkout event, so callsites (EntitlementsSection,
// SubscriptionRecaptureBanner, Booking page) don't have to.
import { UserAPI } from "@shared/types";
import { PaymentModalV2 } from "./PaymentModalV2";
import { useEffect } from "react";
import tracking from "@/lib/tracking";

interface PaymentModalProps {
  bookingId?: string;
  paymentOptions: UserAPI.PaymentOption[];
  startDate?: Date | null;
  /** Open with this plan chosen. */
  preselectedOptionId?: string;
  /** Show only subscription plans (no single-outing option) — e.g. the Kiki gate. */
  subscriptionOnly?: boolean;
  /** A coupon already applied to `paymentOptions` upstream (onboarding's plan screen). */
  couponCode?: string;
  onSuccess: () => void;
  onCancel: () => void;
}

export function PaymentModal(props: PaymentModalProps) {
  useEffect(() => {
    tracking.initiateCheckout();
  }, []);
  return <PaymentModalV2 {...props} />;
}
